// Lead status options used in Leads list filter and Create/Edit Lead forms (industry-standard)
export const LEAD_STATUSES = [
  'New',
  'Connected',
  'Follow Up',
  'Not Connected',
  'Contacted',
  'Quotation Send',
  'Interested',
  'Price High',
  'Stock Not available',
  'In Progress',
  'Negotiation',
  'On Hold',
  'Call Back Requested',
  'No Response',
  'Wrong Number',
  'Qualified',
  'Closed - Won',
  'Closed - Lost',
  'Lost',
  'Converted',
  'Outside Location',
] as const;

export type LeadStatus = (typeof LEAD_STATUSES)[number];
